import { Stack } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

import { TitlePage } from '../../components/TitlePage';
import useFetch from '../../hooks/useFetch';
import { urlGetEstimateById } from '../../helpers/urls';
import { ClientData } from './components/ClientData';
import { EstimateData } from './components/EstimateDate';

export const DetailEstimate = ({ idEstimate = 1 }) => {

    const { loading, data } = useFetch(urlGetEstimateById+ '?id=' + idEstimate);

    const { contact, client } = !!data && data[0];

    return (
        <Stack width='100%' alignItems='center'>
            <TitlePage title={title} subtitle={subtitle + contact} buttonTitle={buttonTitle} />
            {loading
                ? <CircularProgress size={70} />
                : <Stack width='100%' justifyContent='space-between'>
                    <ClientData client={client}/>
                    <EstimateData data={data}/>
                </Stack>
            }
        </Stack>
    )
}

const title = 'Presupuesto: ';
const subtitle = 'Persona de contacto: ';
const buttonTitle = 'Editar presupuesto';